import jwt_decode from "jwt-decode";

interface JWTClaims {
  exp: number;
  // Analytics only
  cache_id?: number;
  username?: string;
  provider?: string; // SSO only, not Basic auth
  // CacheSight only
  pwUnset?: boolean; // Login only, not password reset. True if using default password.
}

// Allow `null` as `jwt` param type to permit passing localStorage item
// e.g. `decodeJWT(localStorage.getItem('token')`
// Also used for Analytics SSO, where a string is passed, hence not
// handling `localStorage.getItem()` within the function
export function decodeJWT(jwt?: string | null): false | JWTClaims {
  if (!jwt) return false;

  try {
    return jwt_decode(jwt) as JWTClaims;
  } catch {
    return false;
  }
}
